import http from '@/services/rest/rest.service';
import { ISearchBody, ISortBody } from '@/entities/search-body.interface';
import { IAccount } from '@/entities/accounts/account.interface';
import { MeModel } from '@/entities/accounts/me-model.interface';

export default {
    unapproved(sortBody: ISortBody): Promise<IAccount[]> {
        return http.get('accounts/unapproved', sortBody);
    },
    unapprovedCount(): Promise<number> {
        return http.get('/accounts/unapproved/count');
    },
    approveBatch(ids: number[]): Promise<void> {
        return http.put(`accounts/approve`, { ids });
    },
    me(): Promise<MeModel> {
        return http.get(`accounts/me`);
    },
    migrate(): Promise<number> {
        return http.get(`accounts/migrate`);
    }
};
